import { useQuery, type QueryKey } from '@tanstack/react-query';
import userService from '@/api/services/user';

export const useGetAllUsersQueryKey = () => ['users'] as QueryKey;
export const useGetAllUsers = () => {
  return useQuery({
    queryKey: useGetAllUsersQueryKey(),
    queryFn: ({ signal }) => userService.getAllUsers(signal),
  });
};

export const useGetCurrentUserDetailsQueryKey = () => ['current-user-details'] as QueryKey;
export const useGetCurrentUserDetails = () => {
  return useQuery({
    queryKey: useGetCurrentUserDetailsQueryKey(),
    queryFn: ({ signal }) => userService.getCurrentUserDetails(signal),
  });
};
